import { supabase } from '@/integrations/supabase/client';

const API_BASE = (import.meta.env.VITE_SUPABASE_URL ?? 'https://beta.crm-api.primetecia.com.br/api').replace(/\/+$/, '');

export async function pedidoAceiteCpf(pedidoId: string, acao?: string, body?: unknown) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Entre novamente no CRM.');
  const response = await fetch(`${API_BASE}/v1/pedidos/${pedidoId}/aceite-cpf${acao ? `/${acao}` : ''}`, {
    method: acao ? 'POST' : 'GET', headers: { Authorization: `Bearer ${session.access_token}`, 'Content-Type': 'application/json' },
    ...(acao ? { body: JSON.stringify(body || {}) } : {}),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Não foi possível consultar o aceite.');
  return result;
}

export async function concluirCriacaoSeCpf(pedidoId: string, itemIds: string[]) {
  const { data, error } = await supabase.from('pedidos').select('cliente_id').eq('id', pedidoId).single();
  if (error) throw error;
  if (!data?.cliente_id) throw new Error('Pedido sem cliente.');
  const { data: cliente, error: erroCliente } = await supabase.from('clientes').select('tipo_pessoa').eq('id', data.cliente_id).single();
  if (erroCliente) throw erroCliente;
  if (cliente?.tipo_pessoa !== 'PF') return null;
  return pedidoAceiteCpf(pedidoId, 'concluir-criacao', { itemIds });
}
